import { Box, Container, IconButton, Stack, Typography } from '@mui/material';
import { Twitter } from '@mui/icons-material';

const ordinalsPlayXUrl = 'https://twitter.com/OrdinalsPlay';

const V2Footer = () => (
  <Box
    component="footer"
    sx={{
      mt: 'auto',
      py: { xs: 4, md: 5 },
      borderTop: '1px solid rgba(255,255,255,0.06)',
      backgroundColor: 'rgba(7,9,13,0.82)',
    }}
  >
    <Container
      maxWidth={false}
      sx={{
        maxWidth: 1328,
        px: { xs: 2, sm: 3 },
        display: 'grid',
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: '1fr auto 1fr' },
        alignItems: 'center',
        gap: { xs: 3, md: 5 },
      }}
    >
      <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
        <Typography sx={{ fontSize: 14, fontWeight: 800, letterSpacing: '-0.02em' }}>
          ORDINALS <Box component="span" sx={{ color: 'primary.main' }}>PLAY</Box> V2
        </Typography>
        <Typography
          color="text.secondary"
          sx={{ mt: 0.75, maxWidth: { md: 380 }, fontSize: 11, lineHeight: 1.65 }}
        >
          Bitcoin Ordinals games delivered through the existing Unity WebGL arcade.
        </Typography>
      </Box>

      <Stack direction="row" justifyContent="center" aria-label="Ordinals Play social links">
        <IconButton
          component="a"
          href={ordinalsPlayXUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Ordinals Play on X"
          sx={{
            width: 40,
            height: 40,
            color: '#A3A3A3',
            border: '1px solid rgba(255,255,255,0.07)',
            borderRadius: 2,
            backgroundColor: 'rgba(255,255,255,0.035)',
            '&:hover': {
              color: '#fff',
              borderColor: 'rgba(255,255,255,0.14)',
              backgroundColor: 'rgba(255,255,255,0.07)',
            },
          }}
        >
          <Twitter aria-hidden="true" sx={{ fontSize: 18 }} />
        </IconButton>
      </Stack>

      <Box sx={{ textAlign: { xs: 'center', md: 'right' } }}>
        <Typography
          className="v2-technical-label"
          sx={{ color: '#737373', fontSize: 10, letterSpacing: '0.08em' }}
        >
          © {new Date().getFullYear()} Ordinals Play
        </Typography>
        <Typography
          className="v2-technical-label"
          sx={{ mt: 0.75, color: '#525252', fontSize: 9, letterSpacing: '0.1em' }}
        >
          Unity WebGL Arcade
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default V2Footer;
